import { Button, Center, Text, VStack } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import LockIcon from '@/assets/icons/ic-lock.svg';

export const ChatUnauthorized: FC = () => {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <Center>
      <VStack>
        <LockIcon width="60px" height="60px" color="#CACCCC" />
        <Text w={{ base: '100%', md: '80%' }} textAlign="center">
          {t('conversation.invalidSessionMessage')}
        </Text>

        <NextLink
          href={`/log-in?redirectUrl=${router.asPath === '/log-in' ? '/' : router.asPath}`}
          passHref
          legacyBehavior
        >
          <Button as="a" height="40px">
            {t('action.logIn')}
          </Button>
        </NextLink>
      </VStack>
    </Center>
  );
};
